var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCerrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D5007F",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.804 8.094l2.412-2.418c.223-.219.223-.578 0-.799-.22-.223-.58-.223-.8 0L8.002 7.29 5.576 4.866c-.221-.221-.584-.221-.803 0-.221.221-.221.58 0 .801l2.424 2.427-2.436 2.433c-.22.224-.22.582 0 .804.11.113.257.17.403.17.143 0 .29-.057.402-.17l2.436-2.433 2.425 2.423c.11.111.255.166.4.166.146 0 .291-.055.4-.166.223-.218.223-.581 0-.804L8.805 8.094z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85 12.97c-1.295 1.3-3.02 2.015-4.854 2.015s-3.557-.716-4.855-2.014c-2.678-2.673-2.678-7.028 0-9.707 1.298-1.295 3.02-2.01 4.855-2.01 1.834 0 3.559.715 4.854 2.01 1.299 1.296 2.012 3.018 2.012 4.855 0 1.832-.713 3.557-2.012 4.852m.803-10.51C12.144.947 10.134.115 7.996.115 5.86.116 3.85.948 2.338 2.46c-3.117 3.123-3.117 8.195 0 11.313 1.511 1.514 3.521 2.346 5.658 2.346 2.138 0 4.148-.832 5.657-2.346 1.51-1.508 2.342-3.517 2.342-5.654 0-2.139-.831-4.147-2.342-5.659"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCerrar);
export default __webpack_public_path__ + "static/media/icono_cerrar.dbe234f44cfd19a27c4c287185efe7ea.svg";
export { ForwardRef as ReactComponent };